import { render, staticRenderFns } from "./EqualOrganizationEdit.vue?vue&type=template&id=22939cf8&"
import script from "./EqualOrganizationEdit.vue?vue&type=script&lang=js&"
export * from "./EqualOrganizationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports